import React from 'react';

// 34) Then we need to import our Route Component from react-router-dom ...

// import { Route } from 'react-router-dom';

// 36) Now we need to import our NavLink component ...

// import { Route, NavLink } from 'react-router-dom';

// 40) You may have noticed that when you first navigate to the courses page that the page is blank. react-router-dom provides an intelligent redirect component that instructs the router to redirect from one route to another. First let's import that ...

import { Route, NavLink, Redirect } from 'react-router-dom';

// 33) First we need to import our subcomponents that get rendered into our Courses component ...

// 54) Now we can delete the imports for the HTML, CSS, and JavaScript components. Do this then ((go to CourseContainer.js))

// import HTML from './courses/HTML';
// import CSS from './courses/CSS';
// import JavaScript from './courses/JavaScript';

// 53) Now let's import the new course container component.

import CourseContainer from './courses/CourseContainer';

// 55) Now we add the HTMLCourses import here (remember to adjust the file path)

// import { HTMLCourses } from '../data/courses';

// 56) Next we want to add the CSSCourses and JSCourses to this import ...

import { HTMLCourses, CSSCourses, JSCourses } from '../data/courses';


// const Courses = () => (
//   <div className="main-content courses">
//     <div className="course-header group">
//       <h2>Courses</h2>
//       <ul className="course-nav">
//         <li><a href='/courses/html'>HTML</a></li>
//         <li><a href='/courses/css'>CSS</a></li>
//         <li><a href='/courses/javascript'>JavaScript</a></li>
//       </ul>
//     </div>
//
//     {/* Write routes here... */}
//   </div>
// );

// 35) Now we will add our three routes below our sub-navigation ...

// const Courses = () => (
//   <div className="main-content courses">
//     <div className="course-header group">
//       <h2>Courses</h2>
//       <ul className="course-nav">
//         <li><a href='/courses/html'>HTML</a></li>
//         <li><a href='/courses/css'>CSS</a></li>
//         <li><a href='/courses/javascript'>JavaScript</a></li>
//       </ul>
//     </div>
//
//     <Route path="/courses/HTML" component={HTML} />
//     <Route path="/courses/css" component={CSS} />
//     <Route path="/courses/javascript" component={JavaScript} />
//
//   </div>
// );

// 37) Now we replace our <a> tags in our sub-navigation with NavLink components and we replace the 'href' attribute with the 'to' attribute  (??? Why were the <a> links working without this change ???) ...

// 38) Also remember for now that you will need to have '/' before each route path to a sub-component. If you don't then the routes will not match and you will get a blank page. But we will fix this later on.

// 39) You may have also noticed that when you first navigate to the courses page that the page is blank. We will fix that next.

// const Courses = () => (
//   <div className="main-content courses">
//     <div className="course-header group">
//       <h2>Courses</h2>
//       <ul className="course-nav">
//         <li><NavLink to='/courses/html'>HTML</NavLink></li>
//         <li><NavLink to='/courses/css'>CSS</NavLink></li>
//         <li><NavLink to='/courses/javascript'>JavaScript</NavLink></li>
//       </ul>
//     </div>
//
//     <Route path="/courses/HTML" component={HTML} />
//     <Route path="/courses/css" component={CSS} />
//     <Route path="/courses/javascript" component={JavaScript} />
//
//   </div>
// );

// 41) Now just above our routes we will add a redirect component. Because we are in the Courses component the Courses route will redirect to the '/courses/html' route.

// const Courses = () => (
//   <div className="main-content courses">
//     <div className="course-header group">
//       <h2>Courses</h2>
//       <ul className="course-nav">
//         <li><NavLink to='/courses/html'>HTML</NavLink></li>
//         <li><NavLink to='/courses/css'>CSS</NavLink></li>
//         <li><NavLink to='/courses/javascript'>JavaScript</NavLink></li>
//       </ul>
//     </div>
//
//     <Redirect to="/courses/html" />
//     <Route path="/courses/html" component={HTML} />
//     <Route path="/courses/css" component={CSS} />
//     <Route path="/courses/javascript" component={JavaScript} />
//
//   </div>
// );

// 42) ??? You may have noticed that when we click on our Courses link when we are already in the courses component, we lose our redirct and the courses page is blank. ??? Also from the CSS, html or Javascript pages if we refresh the page from the CSS or JavaScript page we redirect to the HTML page. ??? This is happening because sometimes when we are redirecting from deeply nested routes the url gets out of sync with the UI. ??? To fix this we need to override the existing courses route and render a redirect component that will navigate to the new location. To do this we create a new Route component that returns the redirect component that we just wrote. Also be sure to add the 'exact' attribute ...

// const Courses = () => (
//   <div className="main-content courses">
//     <div className="course-header group">
//       <h2>Courses</h2>
//       <ul className="course-nav">
//         <li><NavLink to='/courses/html'>HTML</NavLink></li>
//         <li><NavLink to='/courses/css'>CSS</NavLink></li>
//         <li><NavLink to='/courses/javascript'>JavaScript</NavLink></li>
//       </ul>
//     </div>
//
//     <Route exact path="/courses" render={ () => <Redirect to="/courses/html"/> }/>
//     <Route path="/courses/html" component={HTML} />
//     <Route path="/courses/css" component={CSS} />
//     <Route path="/courses/javascript" component={JavaScript} />
//
//   </div>
// );

// 43) When you render a component with a route, react-router passes the component additional information about the current path name and the path and URL the route is matching. If you inspect the courses component in react dev tools, you will see three props being passed to it; history, location, and match. Match contains information about how a route is matching the URL. ??? For example the path property let's us know that 'Courses' uses the '/courses' path. And the URL property tells us that it is matching the '/courses' portion of the URL. ??? We can access this data from inside components being rendered by routes. The path and URL properties are useful when building nested routes and links. Let's take advantage of this data to have our courses routes and links dynamically match the current URL and path. That way we don't have to worry if we omitted a forward slash, or if our nested routes and links are going to match the current URL.

// 44) First we pass our match object into the courses function using a react expresssion {match}. Then we pass our nav links the portion of the URL to match (match.url) ??? which you can access from the URL property using a JavaScript expression. ??? We will do the same for CSS and JavaScript ...

// const Courses = ({match}) => (
//   <div className="main-content courses">
//     <div className="course-header group">
//       <h2>Courses</h2>
//       <ul className="course-nav">
//         <li><NavLink to={`${match.url}/html`}>HTML</NavLink></li>
//         <li><NavLink to={`${match.url}/css`}>CSS</NavLink></li>
//         <li><NavLink to={`${match.url}/javascript`}>JavaScript</NavLink></li>
//       </ul>
//     </div>
//
//     <Route exact path="/courses" render={ () => <Redirect to="/courses/html"/> }/>
//     <Route path="/courses/html" component={HTML} />
//     <Route path="/courses/css" component={CSS} />
//     <Route path="/courses/javascript" component={JavaScript} />
//   </div>
// );

// 45) In our routes we will follow the same steps only this time we will use the value of match.path, which will return the string "/courses". ??? First in the redirect route we will set the path to 'match.path' using a react expression. Then we set the redirect to `${match.path}/html` using a javascript expression. ??? Then we do the same for the other three routes (HTML, CSS, and JavaScript). So now even if we change any of the paths later on, everything will still work as expected. Our nav links and routes will always match and render correctly. See below then go to ((App.js))

// const Courses = ({match}) => (
//   <div className="main-content courses">
//     <div className="course-header group">
//       <h2>Courses</h2>
//       <ul className="course-nav">
//         <li><NavLink to={`${match.url}/html`}>HTML</NavLink></li>
//         <li><NavLink to={`${match.url}/css`}>CSS</NavLink></li>
//         <li><NavLink to={`${match.url}/javascript`}>JavaScript</NavLink></li>
//       </ul>
//     </div>
//
//     <Route exact path={match.path} render={ () => <Redirect to={`${match.path}/html`} /> }/>
//     <Route path={`${match.path}/html`} component={HTML} />
//     <Route path={`${match.path}/css`} component={CSS} />
//     <Route path={`${match.path}/javascript`} component={JavaScript} />
//   </div>
// );

// 57) Now inside the Courses component we have three routes. We replace the component attribute with the render attribute. We then set the render attribute equal to an anonymous function that returns the <CourseContainer/> component.

// const Courses = ({match}) => (
//   <div className="main-content courses">
//     <div className="course-header group">
//       <h2>Courses</h2>
//       <ul className="course-nav">
//         <li><NavLink to={`${match.url}/html`}>HTML</NavLink></li>
//         <li><NavLink to={`${match.url}/css`}>CSS</NavLink></li>
//         <li><NavLink to={`${match.url}/javascript`}>JavaScript</NavLink></li>
//       </ul>
//     </div>
//
//     <Route exact path={match.path} render={ () => <Redirect to={`${match.path}/html`} /> }/>
//     <Route path={`${match.path}/html`} render={ () => <CourseContainer/> } />
//     <Route path={`${match.path}/css`} render={ () => <CourseContainer/> } />
//     <Route path={`${match.path}/javascript`} render={ () => <CourseContainer/> } />
//   </div>
// );

// 58) Now to pass it the course data we will give the component the 'data' property ...

// const Courses = ({match}) => (
//   <div className="main-content courses">
//     <div className="course-header group">
//       <h2>Courses</h2>
//       <ul className="course-nav">
//         <li><NavLink to={`${match.url}/html`}>HTML</NavLink></li>
//         <li><NavLink to={`${match.url}/css`}>CSS</NavLink></li>
//         <li><NavLink to={`${match.url}/javascript`}>JavaScript</NavLink></li>
//       </ul>
//     </div>
//
//     <Route exact path={match.path} render={ () => <Redirect to={`${match.path}/html`} /> }/>
//
//     <Route path={`${match.path}/html`} render={ () => <CourseContainer data={} /> } />
//     <Route path={`${match.path}/css`} render={ () => <CourseContainer data={} /> } />
//     <Route path={`${match.path}/javascript`} render={ () => <CourseContainer data={}/> } />
//   </div>
// );

// 59) Now we will pass into the data attribute the data from the various arrays for each repective path (HTMLCourses, CSSCourses, JSCourses) Do this then ((Go to CourseContainer.js))

const Courses = ({match}) => (
  <div className="main-content courses">
    <div className="course-header group">
      <h2>Courses</h2>
      <ul className="course-nav">
        <li><NavLink to={`${match.url}/html`}>HTML</NavLink></li>
        <li><NavLink to={`${match.url}/css`}>CSS</NavLink></li>
        <li><NavLink to={`${match.url}/javascript`}>JavaScript</NavLink></li>
      </ul>
    </div>

    <Route exact path={match.path} render={ () => <Redirect to={`${match.path}/html`} /> }/>

    <Route path={`${match.path}/html`} render={ () => <CourseContainer data={HTMLCourses} /> } />
    <Route path={`${match.path}/css`} render={ () => <CourseContainer data={CSSCourses} /> } />
    <Route path={`${match.path}/javascript`} render={ () => <CourseContainer data={JSCourses}/> } />
  </div>
);

export default Courses;



// WEBPACK FOOTER //
// ./src/components/Courses.js